import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { normalizeTime } from '../utils/timeNormalizer';

dayjs.extend(relativeTime);

// Ensures the timestamp column has a consistent minimum width for 2-char values (e.g. "1h")
const TIMESTAMP_MIN_WIDTH = '24px';

export const TimeElapsedSinceNotification = ({ datetime }: { datetime: dayjs.Dayjs }) => {
  const fromNowString = datetime.fromNow(true).toString();
  const timeElapsedSinceNotification = normalizeTime(fromNowString);

  return (
    <Stack
      sx={{
        minWidth: TIMESTAMP_MIN_WIDTH,
        flexShrink: 0,
        textAlign: 'right',
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        fontSize="12px"
        fontWeight={600}
        sx={{
          fontVariantNumeric: 'tabular-nums',
          letterSpacing: '0.02em',
        }}
      >
        {timeElapsedSinceNotification}
      </Typography>
    </Stack>
  );
};
